export enum EnvironmentsEnum {
  production = 'prod',
  ci = 'ci',
  staging = 'stage',
  demo = 'demo',
  develop = 'dev',
}
